import { makeAutoObservable } from 'mobx';

export default class Vacancies {
  vacancies = [];
  hotVacancies = [];
  search = '';

  constructor() {
    makeAutoObservable(this);
  }

  setVacancies(payload) {
    this.vacancies = payload;
    this.hotVacancies = payload?.filter(({ isHot }) => isHot);
  }

  getVacancies() {
    return {
      vacancies: this.vacancies,
      hotVacancies: this.hotVacancies,
      loading: !this.vacancies?.length,
    };
  }

  setSearch(search) {
    this.search = search;
  }
}
